const SystemParam = {}; //系统参数设置
const UserPower = {}; //用户权限
const PrintMenu = {}; //打印菜单
const ButtonPowerList = [];
const TablePage = {
	PageSizes: [10, 20, 30, 50, 100],
	DefaultSizes: 20
};

const BUILD_TYPE = process.env.BUILD_TYPE;

//配置地址端口信息
let host = window.location.hostname;
let port = window.location.port;
if (process.env.BUILD_TYPE == 'dev') {
	host = process.env.SERVER_HOST;
	port = process.env.SERVER_PORT;
} else if (process.env.BUILD_TYPE == 'prod') {
	host = window.location.hostname;
	port = window.location.port;
}

const protocol = process.env.BUILD_TYPE == 'dev' ? 'http:' : (window.location.protocol || 'http:');
const wsProtocol = protocol == 'https:' ? 'wss:' : 'ws:';
const portPart = port ? ':' + port : '';
const httpURL = protocol + '//' + host + portPart;
const websocketurl = wsProtocol + '//' + host + portPart + '/webSocket';

const fileupload = httpURL + '/file/uploadimg';
const printViewURL = httpURL + '/PrintReport/Views/ReportViewWebApp.html';
const printServiceURL = httpURL + '/PrintReport/Httphandler/Print/GetReportData.ashx';
export default {
	TablePage,
	SystemParam,
	UserPower,
	ButtonPowerList,
	httpURL,
	fileupload,
	printViewURL,
	printServiceURL,
	websocketurl,
	SetHttpURL(url) {
		let that = this;
		that.httpURL = url;
	},
	SetSystemParam(ParamList) {
		let that = this;
		if (ParamList == null || ParamList == undefined) {
			return;
		}
		let DecimalPlaces = {};

		ParamList.forEach((item) => {
			switch (item.paramValueType) {
				case "数值":
					that.SystemParam[item.paramKey] = parseFloat(item.paramValue);
					break;
				case "布尔":
					that.SystemParam[item.paramKey] = (item.paramValue == "true" ? true : false)
					break;
				case "字符串":
					that.SystemParam[item.paramKey] = item.paramValue;
					break;
			}

			switch (item.paramKey) {
				case "DecimalPlaces_Amount":
					DecimalPlaces["Amount"] = parseFloat(item.paramValue);
					break;
				case "DecimalPlaces_Price":
					DecimalPlaces["Price"] = parseFloat(item.paramValue);
					break;
				case "DecimalPlaces_BillPrice":
					DecimalPlaces["BillPrice"] = parseFloat(item.paramValue);
					break;
				case "DecimalPlaces_ChangeRate":
					DecimalPlaces["ChangeRate"] = parseFloat(item.paramValue);
					break;
				case "DecimalPlaces_QualifiedRate":
					DecimalPlaces["QualifiedRate"] = parseFloat(item.paramValue);
					break;
				case "DecimalPlaces_LossRate":
					DecimalPlaces["LossRate"] = parseFloat(item.paramValue);
					break;
				case "DecimalPlaces_Amount_GiveUpZero":
					DecimalPlaces["IsAmountGiveUpZero"] = (item.paramValue == "true" ? true : false)
					break;
				case "DecimalPlaces_Price_GiveUpZero":
					DecimalPlaces["IsPriceGiveUpZero"] = (item.paramValue == "true" ? true : false)
					break;
				case "DecimalPlaces_BillPrice_GiveUpZero":
					DecimalPlaces["IsBillPriceGiveUpZero"] = (item.paramValue == "true" ? true : false)
					break;
				case "DecimalPlaces_ChangeRate_GiveUpZero":
					DecimalPlaces["IsChangeRateGiveUpZero"] = (item.paramValue == "true" ? true : false)
					break;
				case "DecimalPlaces_QualifiedRate_GiveUpZero":
					DecimalPlaces["IsQualifiedRateGiveUpZero"] = (item.paramValue == "true" ? true : false)
					break;
				case "DecimalPlaces_LossRate_GiveUpZero":
					DecimalPlaces["IsLossRateGiveUpZero"] = (item.paramValue == "true" ? true : false)
					break;
			}

			that.SystemParam["DecimalPlaces"] = DecimalPlaces;
		})
	},
	GetSystemParam(_paramKey) {
		return this.SystemParam[_paramKey];
	},
	SetUserPower(result) {
		let that = this;
		result.pc_power_list.forEach((item) => {
			that.UserPower[item.powerid] = true;
		})

		// result.remind_power_list.forEach((item) => {
		// 	that.UserPower[item.powerid] = true;
		// })
		// result.other_power_list.forEach((item) => {
		// 	that.UserPower[item.powerid] = item.PowerValue;
		// })
	},
	GetPower(value) {
		return this.UserPower[value];
	},

	SetPrintMenu(result) {
		let that = this;
		let _PrintMenu = {};
		result.forEach((item) => {
			if (_PrintMenu[item.MenuId] == null || _PrintMenu[item.MenuId] == undefined) {
				_PrintMenu[item.MenuId] = [];
			}
			_PrintMenu[item.MenuId].push({
				TemplateId: item.TemplateId,
				TemplateName: item.TemplateName,
			})
		})
		that.PrintMenu = _PrintMenu;
	},
	GetPrintMenu(MenuId) {
		return this.PrintMenu[MenuId];
	},

	//数量 小数位数处理（显示用）
	//返回值：数值类型，根据系统参数自动判断是否舍零
	FormatterAmount(value) {
		if (!this.SystemParam) {
			return;
		}

		let limitNumber = this.SystemParam.DecimalPlaces.Amount;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		if (this.SystemParam.DecimalPlaces.IsAmountGiveUpZero) {
			return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
		}
		var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
		if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
			return s;
		}
		while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
			s += '0';
		}
		return s;
	},
	//数量 小数位数处理（用来做一些计算用）
	//返回值：舍零、数值类型
	FormatterFloatAmount(value) {
		if (!this.SystemParam) {
			return;
		}
		let limitNumber = this.SystemParam.DecimalPlaces.Amount;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	},
	//数量 小数位数处理（用来显示3位间隔,）
	//返回值：舍零、数值类型
	FormatterAmountByComma(value) {
		if (!this.SystemParam) {
			return;
		}
		let limitNumber = this.SystemParam.DecimalPlaces.Amount;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber) || 0).toString()
			.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
	},
	//单价 小数位数处理（显示用）
	//返回值：数值类型，根据系统参数自动判断是否舍零
	FormatterPrice(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.Price;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		if (this.SystemParam.DecimalPlaces.IsPriceGiveUpZero) {
			return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
		}
		var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
		if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
			return s;
		}
		while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
			s += '0';
		}
		return s;
	},
	//单价 小数位数处理（用来做一些计算用）
	//返回值：舍零、数值类型
	FormatterFloatPrice(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.Price;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	},
	//单价 小数位数处理（显示用）
	//返回值：舍零、数值类型
	FormatterPriceByComma(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.Price;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	},

	//发票单价 小数位数处理（显示用）
	//返回值：数值类型，根据系统参数自动判断是否舍零
	FormatterBillPrice(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.BillPrice;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		if (this.SystemParam.DecimalPlaces.IsBillPriceGiveUpZero) {
			return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
		}
		var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
		if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
			return s;
		}
		while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
			s += '0';
		}
		return s;
	},
	//发票单价 小数位数处理（用来做一些计算用）
	//返回值：舍零、数值类型
	FormatterFloatBillPrice(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.BillPrice;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	},

	//换算率 小数位数处理（显示用）
	//返回值：数值类型，根据系统参数自动判断是否舍零
	FormatterChangeRate(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.ChangeRate;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		if (this.SystemParam.DecimalPlaces.IsChangeRateGiveUpZero) {
			return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
		}
		var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
		if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
			return s;
		}
		while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
			s += '0';
		}
		return s;
	},
	//换算率 小数位数处理（用来做一些计算用）
	//返回值：舍零、数值类型
	FormatterFloatChangeRate(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.ChangeRate;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	},

	//损耗率 小数位数处理（显示用）
	//返回值：数值类型，根据系统参数自动判断是否舍零
	FormatterLossRate(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.LossRate;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		if (this.SystemParam.DecimalPlaces.IsLossRateGiveUpZero) {
			return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
		}
		var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
		if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
			return s;
		}
		while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
			s += '0';
		}
		return s;
	},
	//损耗率 小数位数处理（用来做一些计算用）
	//返回值：舍零、数值类型
	FormatterFloatLossRate(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.LossRate;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	},

	//合格率 小数位数处理（显示用）
	//返回值：数值类型，根据系统参数自动判断是否舍零
	FormatterQualifiedRate(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.QualifiedRate;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		if (this.SystemParam.DecimalPlaces.IsQualifiedRateGiveUpZero) {
			return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
		}
		var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
		if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
			return s;
		}
		while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
			s += '0';
		}
		return s;
	},
	//合格率 小数位数处理（用来做一些计算用）
	//返回值：舍零、数值类型
	FormatterFloatQualifiedRate(value) {
		let limitNumber = this.SystemParam.DecimalPlaces.QualifiedRate;
		if (value == undefined || value == null || isNaN(value) || value.toString() == '') {
			return 0;
		}
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber);
	},

	//数据排序
	SortBykey(ary, key) {
		return ary.sort(function (a, b) {
			let x = a[key]
			let y = b[key]
			return ((x < y) ? -1 : (x > y) ? 1 : 0)
		})
	},

	//换行符过滤
	FromatterBr(value) {
		if (value != '' & value != undefined & value != null) {
			return value.replace(new RegExp("<br/>", "gm"), "\r\n");
		}
	},
	//获取月初
	getFirstDayOfMonth() {
		const date = new Date();
		var startTime = new Date(date).getTime();
		var year = new Date(startTime).getFullYear(); //获取新的日期的年份
		var month = new Date(startTime).getMonth() + 1; //获取月份
		var day = 1; //获取天 
		month = month > 9 ? month : '0' + month;
		return year + '-' + month + '-' + day;
	},
	getFirstDayOfLastMonth() {
		const date = new Date();
		var startTime = new Date(date).getTime();
		var year = new Date(startTime).getFullYear(); //获取新的日期的年份
		var month = new Date(startTime).getMonth(); //获取月份
		var day = 1; //获取天 
		month = month > 9 ? month : '0' + month;
		return year + '-' + month + '-' + day;
	},
	//获取月末
	getLastDayOfMonth() {
		const date = new Date();
		var startTime = new Date(date).getTime();
		var year = new Date(startTime).getFullYear(); //获取新的日期的年份
		var month = new Date(startTime).getMonth(); //获取月份
		var lastDay = new Date(year, month, 0).getDate();
		if (month == 0) {
			month = 12;
			year = year - 1;
		}
		month = month > 9 ? month : '0' + month;
		lastDay = lastDay > 9 ? lastDay : '0' + lastDay;
		return year + '-' + month + '-' + lastDay;
	},
	//获取年初
	getFirstDayOfYear() {
		const date = new Date();
		var startTime = new Date(date).getTime();
		var year = new Date(startTime).getFullYear(); //获取新的日期的年份
		return year + '-01-01';
	},
	//获取当前日期前后的某一天
	getDayOfToday(dayNumber) {
		let dayNum = 0;
		if (dayNumber == undefined || dayNumber == null || dayNumber == '') {
			dayNum = 0;
		}
		let Millisecond = 0;
		if (dayNumber != '' && dayNumber != undefined) {
			Millisecond = 24 * 60 * 60 * 1000 * dayNumber
		}
		const date = new Date();
		var startTime = new Date(date).getTime() - Millisecond;
		var year = new Date(startTime).getFullYear(); //获取新的日期的年份
		var month = new Date(startTime).getMonth() + 1; //获取月份
		var day = (dayNumber != '' && dayNumber != undefined) ? new Date(startTime).getDate() : '1'; //获取天 
		month = month > 9 ? month : '0' + month;;
		day = day > 9 ? day : '0' + day;
		return year + '-' + month + '-' + day;
	},
	//获取指定日期前后的某一天
	getDayOfFixDate(curdate, dayNumber) {
		let dayNum = 0;
		if (dayNumber == undefined || dayNumber == null || dayNumber == '') {
			dayNum = 0;
		}
		let Millisecond = 0;
		if (dayNumber != '' && dayNumber != undefined) {
			Millisecond = 24 * 60 * 60 * 1000 * dayNumber
		}
		var startTime = new Date(curdate).getTime() - Millisecond;
		var year = new Date(startTime).getFullYear(); //获取新的日期的年份
		var month = new Date(startTime).getMonth() + 1; //获取月份
		var day = (dayNumber != '' && dayNumber != undefined) ? new Date(startTime).getDate() : '1'; //获取天 
		month = month > 9 ? month : '0' + month;;
		day = day > 9 ? day : '0' + day;
		return year + '-' + month + '-' + day;
	},
	//获取指定日期前后的某一天
	getDayOfFixDate(curdate, dayNumber) {
		let dayNum = 0;
		if (dayNumber == undefined || dayNumber == null || dayNumber == '') {
			dayNum = 0;
		}
		let Millisecond = 0;
		if (dayNumber != '' && dayNumber != undefined) {
			Millisecond = 24 * 60 * 60 * 1000 * dayNumber
		}
		var startTime = new Date(curdate).getTime() + Millisecond;
		var year = new Date(startTime).getFullYear(); //获取新的日期的年份
		var month = new Date(startTime).getMonth() + 1; //获取月份
		var day = (dayNumber != '' && dayNumber != undefined) ? new Date(startTime).getDate() : '1'; //获取天 
		month = month > 9 ? month : '0' + month;;
		day = day > 9 ? day : '0' + day;
		return year + '-' + month + '-' + day;
	},
	//在原有的日期基础上，增加 months 月份，默认增加1月
	addMonth(date, months) {
		if (months == undefined || months == '')
			months = 1;
		var date = new Date(date);
		date.setMonth(date.getMonth() + months);
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		month = month > 9 ? month : '0' + month;
		day = day > 9 ? day : '0' + day;
		return year + '-' + month + '-' + day;
	},
	//获取当天
	getNewDate() {
		const nowDate = new Date();
		const date = {
			year: nowDate.getFullYear(),
			month: nowDate.getMonth() + 1,
			date: nowDate.getDate(),
		}
		const newmonth = date.month > 9 ? date.month : '0' + date.month
		const day = date.date > 9 ? date.date : '0' + date.date
		return date.year + '-' + newmonth + '-' + day
	},
	getNewDateTime() {
		const nowDate = new Date();
		const date = {
			year: nowDate.getFullYear(),
			month: nowDate.getMonth() + 1,
			date: nowDate.getDate(),
			hour: nowDate.getHours(),
			minute: nowDate.getMinutes(),
			second: nowDate.getSeconds()
		}
		const newmonth = date.month > 9 ? date.month : '0' + date.month;
		const day = date.date > 9 ? date.date : '0' + date.date;
		const hour = date.hour > 9 ? date.hour : '0' + date.hour;
		const minute = date.minute > 9 ? date.minute : '0' + date.minute;
		const second = date.second > 9 ? date.second : '0' + date.second;

		return date.year + '-' + newmonth + '-' + day + ' ' + hour + ':' + minute + ':' + second;

	},
	//根据身份证获取出生日期
	getBirthdayFromIdCard(idCard) {
		var birthday = "";
		if (idCard != null && idCard != "") {
			if (idCard.length == 15) {
				birthday = "19" + idCard.substr(6, 6);
			} else if (idCard.length == 18) {
				birthday = idCard.substr(6, 8);
			}
			birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
		}
		return birthday;
	},
	//根据身份证获取性别
	getSexFromIdCard(idCard) {
		if (parseInt(idCard.substr(16, 1)) % 2 == 1) {
			//男
			return "男";
		} else {
			//女
			return "女";
		}
	},
	//导出前处理数据
	formatExportJson(filterVal, jsonData) {
		return jsonData.map((v, key) =>
			filterVal.map(j => {
				if (j == 'ID') {
					return (v[j] = key + 1); //遍历序号
				}
				return v[j];
			})
		);
	},
	inputNumberSelect(e) {
		e.currentTarget.select();
	},
	// Excel导入-限制上传附件类型
	beforeExcelImport(file) {
		// 后缀获取
		var suffix = '';
		try {
			var flieArr = file.name.split('.');
			suffix = flieArr[flieArr.length - 1];
		} catch (err) {
			suffix = '';
		}
		if (!suffix) {
			isfile = false;
			this.$message.error('文件格式错误!');
		}
		var isfile = true;
		if (suffix != 'xls' && suffix != 'xlsx') {
			isfile = false;
			this.$message.error('上传文件只能是Excel格式!');
		}
		return isfile;
	},
	beforeZipImport(file) {
		// 后缀获取
		var suffix = '';
		try {
			var flieArr = file.name.split('.');
			suffix = flieArr[flieArr.length - 1];
		} catch (err) {
			suffix = '';
		}
		if (!suffix) {
			isfile = false;
			this.$message.error('文件格式错误!');
		}
		var isfile = true;
		if (suffix != 'zip' && suffix != 'rar') {
			isfile = false;
			this.$message.error('上传文件只能是压缩文件!');
		}
		return isfile;
	}
}



// WEBPACK FOOTER //
// ./src/common/js/param_util.js